export const getRandomMessage = <
	T extends { title: string; description: string }
>(
	messages: T[]
): T => {
	const index = Math.round(Math.random() * (messages.length - 1))

	return messages[index]
}
